import { connect } from 'react-redux';
import { getArray } from '~/utils/arrays';
import { isAPIGroup } from '~/utils/types';
import DependencyList from './DependencyList';

const mapStateToProps = (state, { asset }) => ({
  dependencies: getArray(asset.dependencies) || [],
  showDependencyList:
    !isAPIGroup(asset) &&
    !!asset.dependencies &&
    !!Object.keys(asset.dependencies).length
});

export default connect(mapStateToProps)(DependencyList);
